export default __webpack_public_path__ + "static/harvest-hush-screen-0abb3bea0bfaeddca104f97f631315a9.svg";